export default __webpack_public_path__ + "static/media/woolpert.94db1fde.jpg";